var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          staticClass: "card-detail-drawer",
          attrs: {
            visible: _vm.visible,
            direction: "rtl",
            "with-header": false,
            size: "50%",
            "destroy-on-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "drawer-container" }, [
            _c("div", { staticClass: "drawer-header" }, [
              _c("span", { staticClass: "drawer-title" }, [
                _vm._v("福卡详情 "),
                _vm.cardDetail.id
                  ? _c("small", [_vm._v("ID: " + _vm._s(_vm.cardDetail.id))])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "drawer-actions" },
                [
                  _c(
                    "el-tooltip",
                    { attrs: { content: "复制卡片信息", placement: "top" } },
                    [
                      _c("el-button", {
                        attrs: {
                          type: "primary",
                          icon: "el-icon-document-copy",
                          size: "mini",
                          plain: "",
                        },
                        on: { click: _vm.copyCardInfo },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-button", {
                    attrs: { icon: "el-icon-close", circle: "", size: "mini" },
                    on: {
                      click: function ($event) {
                        _vm.visible = false
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "drawer-content" }, [
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "skeleton-loading" },
                    _vm._l(3, function (i) {
                      return _c(
                        "div",
                        { key: i, staticClass: "skeleton-section" },
                        [
                          _c("div", { staticClass: "skeleton-title" }),
                          _vm._v(" "),
                          _vm._l(3, function (j) {
                            return _c(
                              "div",
                              { key: j, staticClass: "skeleton-row" },
                              [
                                _c("div", { staticClass: "skeleton-item" }),
                                _vm._v(" "),
                                _c("div", { staticClass: "skeleton-item" }),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "scrollable-content" }, [
                    _c(
                      "div",
                      { staticClass: "card-section" },
                      [
                        _c("h3", { staticClass: "section-title" }, [
                          _vm._v(
                            _vm._s(_vm.cardType === 3 ? "卡包详情" : "卡片详情")
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { staticClass: "info-row", attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("卡片ID"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.cardDetail.id || "-")),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("卡片名称"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.cardDetail.relatedCard || "-")
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.cardType === 3
                                        ? "卡包状态"
                                        : "卡片状态"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.cardDetail.cardStatus)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { staticClass: "info-row", attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.cardType === 3
                                        ? "卡包面值"
                                        : "卡片面值"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.cardDetail.faceValue || "¥0")
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("可用余额"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.cardDetail.availableAmount || "¥0"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("有效期限"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.cardDetail.validityPeriod || "-")
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { staticClass: "info-row", attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("发放时间"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.cardDetail.releaseTime)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("发放小程序"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.cardDetail.miniappName)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("归属客户"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.cardDetail.customerName)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("h3", { staticClass: "section-title" }, [
                          _vm._v("项目信息"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { staticClass: "info-row", attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("项目名称"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.cardDetail.projectName)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("项目类型"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.cardDetail.projectType)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("项目状态"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.cardDetail.projectStatus)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.cardType === 3
                          ? _c(
                              "el-row",
                              {
                                staticClass: "info-row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("div", { staticClass: "info-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("关联福卡ID"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.cardDetail.cardPackageId || "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 16 } }, [
                                  _c("div", { staticClass: "info-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("关联福卡名称"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.cardDetail.cardPackageName || "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { staticClass: "info-row", attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("项目ID"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.cardDetail.projectId || "-")
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("项目编号"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.cardDetail.projectNumber || "-")
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("申请编号"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.cardDetail.applicationNumber || "-"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticClass: "info-row remark-row",
                            attrs: { gutter: 20 },
                          },
                          [
                            _c("el-col", { attrs: { span: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("项目备注"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "value remark-text" },
                                  [_vm._v(_vm._s(_vm.cardDetail.projectRemark))]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("内部备注"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "value remark-text" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.cardDetail.internalRemark)
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-section" },
                      [
                        _c("h3", { staticClass: "section-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.cardType === 3
                                ? "卡包收支明细"
                                : "卡片收支明细"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading",
                              },
                            ],
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.transactionData,
                              border: "",
                              size: "small",
                              "max-height": "300",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "id",
                                label: "ID",
                                width: "80",
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "typeName",
                                label: "变动类型",
                                width: "120",
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "integral",
                                label: "变动额度",
                                width: "120",
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "remark",
                                label: "原因",
                                "min-width": "150",
                                align: "center",
                                "show-overflow-tooltip": true,
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "orderNo",
                                label: "关联订单",
                                "min-width": "150",
                                align: "center",
                                "show-overflow-tooltip": true,
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "变动时间",
                                "min-width": "150",
                                align: "center",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatDateTime(
                                              scope.row.createTime
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-pagination", {
                          staticClass: "pagination",
                          attrs: {
                            "current-page": _vm.pagination.page,
                            "page-sizes": [20, 40, 60, 80, 100],
                            "page-size": _vm.pagination.limit,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.pagination.total,
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.handleCurrentChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }